<template>
  <div>
    <Head title="Productos" />

    <!-- 1. Header & Acciones Principales -->
    <ProductHeader 
      title="Productos"
      :total-count="stats?.total"
      create-url="/products/create"
      create-label="Crear Producto"
      :has-export="true"
      :has-import="true"
      export-excel-url="/products/export/excel"
      export-pdf-url="/products/export/pdf"
      @open-import="isImportModalOpen = true"
    />

    <!-- 2. Sección de Estadísticas / KPIs -->
    <ProductStats :stats="stats" />

    <!-- 3. Barra de Búsqueda y Filtros Rápidos -->
    <ProductFilters 
      v-model:search="form.search.terms"
      v-model:type-product="form.search.type_product"
    />

    <!-- 4. Tabla y Listado Principal -->
    <ProductTable 
      :products="products" 
      :change="change"
      :current-query-params="currentQueryParams"
    />

    <!-- 5. Submódulos y Catálogos Auxiliares -->
    <ProductAuxiliaries />

    <!-- 6. Modal de Importación Masiva -->
    <ProductImportModal 
      v-if="isImportModalOpen"
      :csrf="csrf"
      @close="isImportModalOpen = false"
    />
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import pickBy from 'lodash/pickBy'
import throttle from 'lodash/throttle'
import ProductHeader from './Partials/ProductHeader.vue'
import ProductStats from './Partials/ProductStats.vue'
import ProductFilters from './Partials/ProductFilters.vue'
import ProductTable from './Partials/ProductTable.vue'
import ProductAuxiliaries from './Partials/ProductAuxiliaries.vue'
import ProductImportModal from './Partials/ProductImportModal.vue'

export default {
  name: 'ProductsIndex',

  components: {
    Head,
    ProductHeader,
    ProductStats,
    ProductFilters,
    ProductTable,
    ProductAuxiliaries,
    ProductImportModal,
  },

  layout: Layout,

  props: {
    products: {
      type: Object,
      required: true,
    },
    stats: {
      type: Object,
      default: () => null,
    },
    groups: Object,
    brands: Object,
    parts: Object,
    models: Object,
    deposits: Object,
    regions: Object,
    change: {
      type: [Number, String],
      default: 0,
    },
    cop_change: {
      type: [Number, String],
      default: 0,
    },
    csrf: {
      type: String,
      default: '',
    },
    filters: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isImportModalOpen: false,
      form: this.$inertia.form({
        search: {
          terms: this.filters?.search?.terms || '',
          type_product: this.filters?.search?.type_product || '',
          deposit: this.filters?.search?.deposit || '',
          brand_id: this.filters?.search?.brand_id || '',
          part_id: this.filters?.search?.part_id || '',
          truck_model_id: this.filters?.search?.truck_model_id || '',
          region_id: this.filters?.search?.region_id || '',
        },
      }),
    }
  },

  computed: {
    currentQueryParams() {
      return { search: pickBy(this.form.search) }
    },
  },

  watch: {
    'form.search': {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(
          '/products',
          { search: pickBy(this.form.search), page: 1 },
          { preserveState: true, replace: true },
        )
      }, 300),
    },
  },
}
</script>
